import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";
import { auth } from "@clerk/tanstack-react-start/server";

const requireAuth = createServerFn({ method: "GET" }).handler(async () => {
	const { isAuthenticated, userId } = await auth();
	return { isAuthenticated, userId };
});

export const Route = createFileRoute("/_authed")({
	beforeLoad: async ({ location }) => {
		const { isAuthenticated } = await requireAuth();

		if (!isAuthenticated) {
			throw redirect({
				to: "/sign-in",
				search: { redirect: location.pathname },
			});
		}
	},
	component: AuthedLayout,
});

function AuthedLayout() {
	return <Outlet />;
}
